import React from "react";

import DeleteIcon from '@mui/icons-material/DeleteOutline';

export function DeleteIconComponent() {
    return (
        <DeleteIcon></DeleteIcon>
    );}